export const Forms = {
    EDIT_COMPANY: 'editCompany',
    CREATE_COMPANY: 'createCompany',
};
